const RETURN_PATH_KEY = 'dealstack.auth.returnPath';

const isSameOriginPath = (value: string): boolean => {
	if (!value.startsWith('/')) {
		return false;
	}

	try {
		return new URL(value, window.location.origin).origin === window.location.origin;
	} catch {
		return false;
	}
};

/** The path to land on, or null when it is missing or points off this origin. */
export const safeReturnPath = (path: string | null | undefined): string | null =>
	path && isSameOriginPath(path) ? path : null;

export const storeReturnPath = (path: string | null | undefined): void => {
	window.sessionStorage.removeItem(RETURN_PATH_KEY);

	if (!path || !isSameOriginPath(path)) {
		return;
	}

	window.sessionStorage.setItem(RETURN_PATH_KEY, path);
};

export const consumeReturnPath = (): string | null => {
	const stored = window.sessionStorage.getItem(RETURN_PATH_KEY);
	window.sessionStorage.removeItem(RETURN_PATH_KEY);

	if (!stored || !isSameOriginPath(stored)) {
		return null;
	}

	return stored;
};
